import { clientStatisticsReportTypesEnum } from "helpers/enums";
import { columnName, formatValue, typeSpecificProps } from "helpers/reports";
import React from "react";
import CommonReport from "./commonReport";

export default class ClientStatisticsReport extends CommonReport {
    idColumn = {
        Header: "#",
        id: "row",
        filterable: false,
        width: 50,
        sticky: true,
        Cell: ({ row }) => <div>{row.index + 1}</div>,
    };

    extractColumns = () => {
        const { columns } = this.props.data || {};
        const reportColumns = columns.filter((item) => !!item.label);
        if (this.props.type === clientStatisticsReportTypesEnum.OnlyLogists) {
            const logistColumnIndex = reportColumns.findIndex((column) => column.propertyName === "LogistName");
            if (logistColumnIndex >= 0) {
                const [logistColumn] = reportColumns.splice(logistColumnIndex, 1);
                const organizationColumnIndex = reportColumns.findIndex(
                    (column) => column.propertyName === "OrganizationName",
                );
                reportColumns.splice(organizationColumnIndex + 1, 0, logistColumn);
            }
        }
        return [this.idColumn].concat(reportColumns.map(this.cellProps));
    };

    cellProps = (column) => {
        return {
            Header: column.label,
            accessor: (originalRow) =>
                column.index !== null ? originalRow[column.propertyName] : originalRow[columnName(column)],
            show: !column.isAdditionalColumn,
            sticky: ["OrganizationName", "LogistName"].includes(column.propertyName),
            Cell: (props) => {
                const uniqueId = { [`data-${column.propertyName}`.toLowerCase()]: "" };
                return (
                    <div className="long-text" {...uniqueId}>
                        {formatValue(props.value, column.clrType)}
                    </div>
                );
            },
            Footer: () => this.footerVal(column),
            ...typeSpecificProps(column),
        };
    };
}
